module.exports = __webpack_public_path__ + "assets/img/user-crown.2351a78d.svg";